import React from "react";
import {
  LayoutDashboard,
  Calendar,
  BookOpen,
  User,
  MessageSquare,
  Edit3,
  Eye,
  Clock,
  LogOut,
  Menu,
  X,
  Home,
  Settings,
} from "lucide-react";
import { useAuth } from "src/context/AuthContext";
import Sidebar, { SidebarItemType } from "src/components/ui/Sidebar";
import { ROUTES } from "src/routes/RouteConfig";

const TutorSidebar: React.FC = () => {
  const { signOut, user } = useAuth();

  const menuItems: SidebarItemType[] = [
    {
      icon: <LayoutDashboard size={18} />,
      label: "Dashboard",
      path: ROUTES.TUTOR_DASHBOARD.path,
    },
    {
      icon: <Calendar size={18} />,
      label: "My Schedule",
      path: ROUTES.TUTOR_SCHEDULE.path,
    },
    {
      icon: <BookOpen size={18} />,
      label: "Sessions",
      subItems: [
        {
          icon: <Calendar size={16} />,
          label: "Upcoming Sessions",
          path: ROUTES.TUTOR_UPCOMING_SESSIONS.path,
        },
        {
          icon: <Clock size={16} />,
          label: "Session History",
          path: ROUTES.TUTOR_PAST_SESSIONS.path,
        },
        {
          icon: <BookOpen size={16} />,
          label: "All Sessions",
          path: ROUTES.TUTOR_ALL_SESSIONS.path,
        },
        {
          icon: <Edit3 size={16} />,
          label: "Node feedback",
          path: ROUTES.TUTOR_NODE_FEEDBACK.path,
        },
      ],
    },
    {
      icon: <MessageSquare size={18} />,
      label: "Messages",
      path: "/tutor/messages",
    },
    {
      icon: <User size={18} />,
      label: "My Students",
      subItems: [
        {
          icon: <Eye size={16} />,
          label: "Overview",
          path: ROUTES.TUTOR_STUDENT_OVERVIEW.path,
        },
        {
          icon: <Edit3 size={16} />,
          label: "Performance & Activity",
          path: ROUTES.TUTOR_STUDENT_PERFORMANCE.path,
        },
        {
          icon: <BookOpen size={16} />,
          label: "Learning Journey",
          path: ROUTES.TUTOR_STUDENT_JOURNEY.path,
        },
      ],
    },
    {
      icon: <Settings size={18} />,
      label: "Profile",
      subItems: [
        {
          icon: <User size={16} />,
          label: "My Profile",
          path: ROUTES.TUTOR_PROFILE.path,
        },
        {
          icon: <BookOpen size={16} />,
          label: "Resources",
          path: ROUTES.TUTOR_PROFILE_RESOURCES.path,
        },
      ],
    },
  ];

  const handleLogout = async () => {
    await signOut();
  };

  return (
    <Sidebar
      title={
        <div className="flex flex-col items-center">
          <img src="/logo.png" alt="rfLearn logo" className="h-8 w-3/4 mr-20 ml-8 mb-2" />
        </div>
      }
      menuItems={menuItems}
      onLogout={handleLogout}
      logoutIcon={<LogOut size={18} />}
      headerColor="text-rfpurple-500"
      homeLink="/"
      homeIcon={<Home size={20} />}
      expandIcon={<Menu size={16} />}
      collapseIcon={<X size={16} />}
    />
  );
};

export default TutorSidebar;
